import ServiceCategoryPage from "../components/ServiceCategoryPage";
import welderService from "../data/services/welderService";

function Welder() {
  return <ServiceCategoryPage service={welderService} />;
}

export default Welder;